// src/StackedRevenueChart.tsx
import React from "react";
import { Bar } from "react-chartjs-2";
import "./chartConfig";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { TooltipItem } from "chart.js";
import { IRevenueMonth } from "./achievements";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    graphContainer: {
      height: "200px",
      width: "100%",
      maxWidth: "100%",
    },
  })
);

type StackedRevenueChartProps = {
  data: IRevenueMonth[];
  loading: boolean;
};

const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: "top" as const,
      labels: {
        color: "#FFFFFF",
        boxWidth: 14,
        padding: 16,
      },
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: (context: TooltipItem<"bar">) =>
          `$${context?.parsed?.y?.toLocaleString() || 0}`,
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      ticks: { color: "#FFFFFF" },
      grid: { display: false },
    },
    y: {
      stacked: true,
      ticks: {
        color: "#FFFFFF",
        stepSize: 5000, // $15K крок
        callback: (value: string | number) => {
          const val = Number(value);
          if (val >= 1000) {
            return `$${(val / 1000).toFixed(0)}K`;
          }
          return `$${val}`;
        },
      },
      grid: { color: "#2F2F2F" },
      suggestedMax: 120000, // необов'язково, але задає верхню межу $120K
    },
  },
};

const StackedRevenueChart = ({ data }: StackedRevenueChartProps) => {
  const classes = useStyles();

  const revenueChartData = {
    labels: data.map(month => {
      const date = new Date(`${month.month}-01`);
      return date.toLocaleString("default", { month: "short" });
    }),
    datasets: [
      {
        label: "Tips",
        data: data.map(m => m.tips),
        backgroundColor: "#FE5A97",
        stack: "stack1",
      },
      {
        label: "Subscriptions",
        data: data.map(m => m.subscriptions),
        backgroundColor: "#FFD700",
        stack: "stack1",
      },
      {
        label: "Custom Video",
        data: data.map(m => m.customVideoRequests),
        backgroundColor: "#808080",
        stack: "stack1",
      },
      {
        label: "Posts",
        data: data.map(m => m.postPurchases || 0),
        backgroundColor: "#0E43FB",
        stack: "stack1",
      },
    ],
  };

  return (
    <div className={classes.graphContainer}>
      <Bar data={revenueChartData} options={barChartOptions} />
    </div>
  );
};

export default StackedRevenueChart;
